import { Injectable } from '@angular/core';

import { BaseEditService, HttpService, NotificationService } from '../../../../tms-shared';
import { Supplier, SupplierDetails } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SupplierShipperService extends BaseEditService<Supplier, SupplierDetails> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('SupplierShipper', $localize`Supplier Shipper`, httpService, notificationService);
  }
}
